import { createAction } from '@reduxjs/toolkit';

export function createAsyncAction<RequestPayload, SuccessPayload, FailurePayload, CancelPayload>(
  type: string
) {
  return {
    request: createAction<RequestPayload>(`${type}/request`),
    success: createAction<SuccessPayload>(`${type}/success`),
    failure: createAction<FailurePayload>(`${type}/failure`),
    cancel: createAction<CancelPayload>(`${type}/cancel`),
  };
}
